import React from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { createStyles, Theme, Typography } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { blue } from "@material-ui/core/colors";
import { TransitionProps } from "@material-ui/core/transitions";
import Slide from "@material-ui/core/Slide";

interface IProps {
  info: string[] | null;
  clearInfoMessage: Function;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    infoBackground: {
      backgroundColor: blue[600],
      color: theme.palette.common.white,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      textAlign: "center",
      padding: "0.5% 2%",
    },
    snackbar: {
      width: "40%",
    },
  })
);

const InfoAlert: React.FC<IProps> = ({ info, clearInfoMessage }: IProps) => {
  const classes = useStyles();

  const SlideComponent = (props: TransitionProps) => (
    <Slide {...props} direction="left" />
  );
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      TransitionComponent={SlideComponent}
      className={classes.snackbar}
      open={Boolean(info)}
      onClose={() => Boolean(info) && clearInfoMessage()}
      autoHideDuration={5000}
    >
      <Grid container>
        <Grid item xs={12}>
          <Paper className={classes.infoBackground}>
            {info &&
              info.map((item: string, index: number) => (
                <Typography key={index} variant={"button"}>
                  {item}
                </Typography>
              ))}
          </Paper>
        </Grid>
      </Grid>
    </Snackbar>
  );
};

export default InfoAlert;
